import { render, staticRenderFns } from "./Axes_text.vue?vue&type=template&id=5423f94d&"
import script from "./Axes_text.vue?vue&type=script&lang=js&"
export * from "./Axes_text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports